// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Utility Classes */

/* Bootstrap-inspired utilities */

/* Container system */
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

/* Grid system */
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
  padding-right: 15px;
  padding-left: 15px;
}

@media (min-width: 768px) {
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

/* Flexbox utilities */
.d-flex {
  display: flex !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.justify-content-center {
  justify-content: center !important;
}

.align-items-center {
  align-items: center !important;
}

/* Position utilities */
.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

/* Spacing utilities */
.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.p-3 {
  padding: 1rem !important;
}

/* Text utilities */
.text-center {
  text-align: center !important;
}

.text-start {
  text-align: left !important;
}

.text-muted {
  color: #6c757d !important;
  font-size: 0.9rem; /* Increased from default for better readability */
}

.text-danger {
  color: #dc3545 !important;
}

/* Card components */
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card-body {
  flex: 1 1 auto;
  padding: 1rem;
}

.card-title {
  margin-bottom: 0.5rem;
}

.card-text {
  margin-bottom: 0;
}

/* Button components */
.btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #0056b3;
  border-color: #004085;
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}

/* Alert components */
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

/* Form components */
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Enhanced form components */
.exl-form-group {
  margin-bottom: 1.5rem;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.exl-form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: -0.005em;
}

.exl-form-control {
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.95rem;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  background-color: var(--card-background);
  color: var(--text-primary);
  transition:
    border-color var(--transition-speed) ease,
    box-shadow var(--transition-speed) ease,
    background-color var(--transition-speed) ease;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  min-width: 0;
  border: 1.5px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  line-height: 1.5;
  background: var(--card-background);
}

.exl-form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(30, 58, 95, 0.25);
  outline: none;
  caret-color: var(--primary-color);
  color: var(--text-primary);
  background-color: var(--card-background);
  box-shadow: 0 0 0 3px rgba(30, 58, 95, 0.1);
  transform: translateY(-1px);
}

.exl-form-control::placeholder {
  color: var(--text-secondary);
  opacity: 0.8;
  opacity: 0.7;
}

.exl-form-control:focus-visible {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(30, 58, 95, 0.25);
  outline: none;
}

/* Enhanced button components */
.exl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.75rem 1.5rem;
  height: 42px;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: var(--border-radius);
  transition: all var(--transition-speed) var(--transition-spring);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  gap: 0.5rem;
  box-sizing: border-box;
  font-size: 0.95rem;
  letter-spacing: -0.005em;
  border-radius: var(--border-radius-sm);
}

.exl-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.exl-btn:hover::before {
  left: 100%;
}

.exl-btn-primary {
  color: white;
  background: var(--brand-gradient-solid);
  border: none;
  box-shadow: 0 2px 8px var(--brand-glow);
}

.exl-btn-primary:hover {
  background: var(--brand-gradient-solid-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px var(--brand-glow);
}

.exl-btn-secondary {
  color: var(--text-primary);
  background: var(--card-background);
  border-color: var(--border-color);
  backdrop-filter: var(--backdrop-blur);
  -webkit-backdrop-filter: var(--backdrop-blur);
  border: 1.5px solid var(--border-color);
}

.exl-btn-secondary:hover {
  background: var(--card-hover);
  border-color: var(--primary-color);
  transform: translateY(-1px);
  color: var(--primary-color);
}

.exl-btn-block {
  display: flex;
  width: 100%;
}

.exl-btn:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(30, 58, 95, 0.15);
}

/* Pagination */
.exl-pagination {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
}

.exl-pagination .pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: var(--border-radius);
}

.exl-pagination .pagination li a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: var(--primary-color);
  background-color: var(--card-background);
  border: 1px solid var(--border-color);
}

.exl-pagination .pagination li:first-child a {
  margin-left: 0;
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
}

.exl-pagination .pagination li:last-child a {
  border-top-right-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
}

.exl-pagination .pagination li a:hover {
  z-index: 2;
  color: var(--primary-dark);
  background-color: #e9ecef;
  border-color: var(--border-color);
}

.exl-pagination .pagination li.active a {
  z-index: 3;
  color: var(--text-light);
  background-color: var(--primary-color);
}

.exl-pagination .pagination li.disabled a {
  color: var(--text-secondary);
  pointer-events: none;
  background-color: var(--card-background);
  border-color: var(--border-color);
}

/* Container for the pagination */
.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px;
}

/* Remove default list styling */
.pagination li {
  display: inline;
}

/* Style the page links */
.pagination li a,
.pagination li span {
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}

/* First and last child rounded corners */
.pagination li:first-child a {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.pagination li:last-child a {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* Hover state */
.pagination li a:hover {
  background-color: #eee;
  color: #23527c;
}

/* Active state */
.pagination li.active a {
  background-color: #337ab7;
  border-color: #337ab7;
  color: #fff;
  cursor: default;
}

/* Disabled state */
.pagination li.disabled a {
  color: #777;
  cursor: not-allowed;
  background-color: #fff;
  border-color: #ddd;
}

/* Small text - Improved readability */
small {
  font-size: 0.95rem; /* Increased from 0.875em for better readability */
  font-weight: 400;
}

/* Form validation feedback - Improved readability */
.invalid-feedback {
  font-size: 0.9rem; /* Increased from typical 0.875rem for better readability */
  font-weight: 500;
  margin-top: 0.25rem;
  color: var(--danger-color);
}

/* Password strength indicator - Improved readability */
.small {
  font-size: 0.9rem !important; /* Increased from 0.875rem for better readability */
  font-weight: 400;
}

/* Form check labels - Improved readability */
.form-check-label {
  font-size: 0.95rem; /* Increased for better readability */
  font-weight: 400;
  line-height: 1.4;
}

/* Bootstrap alert overrides - Improved readability */
.alert {
  font-size: 0.9rem !important; /* Increased from typical 0.875rem for better readability */
  font-weight: 500;
  line-height: 1.5;
}

.alert-danger {
  font-size: 0.9rem !important;
}

.alert-success {
  font-size: 0.9rem !important;
}

.alert-warning {
  font-size: 0.9rem !important;
}

/* Ensure password strength text is readable */
.mt-1.small.text-muted {
  font-size: 0.9rem !important;
}

/* Spinner Components */
.exl-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  width: 100%;
  gap: 1rem;
}

.exl-loading-text {
  margin: 0;
  color: #6c757d;
  font-size: 0.9rem;
}

.exl-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: exl-spin 1s linear infinite;
}

.exl-spinner-small {
  width: 16px;
  height: 16px;
  border-width: 2px;
}

.exl-spinner-medium {
  width: 20px;
  height: 20px;
  border-width: 2px;
}

.exl-spinner-large {
  width: 24px;
  height: 24px;
  border-width: 3px;
}

.exl-spinner-primary {
  border-color: rgba(30, 58, 95, 0.3);
  border-top-color: var(--primary-color);
}

.exl-spinner-white {
  border-color: rgba(255, 255, 255, 0.3);
  border-top-color: white;
}

/* Button spinner container alignment */
.exl-btn .exl-spinner {
  vertical-align: middle;
}

/* Ensure spinner containers within buttons are properly aligned */
.exl-btn > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

/* Loading dots variant */
.exl-loading-dots {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.exl-loading-dots .exl-dot {
  width: 8px;
  height: 8px;
  background-color: currentColor;
  border-radius: 50%;
  animation: exl-dots-bounce 1.4s ease-in-out infinite both;
}

.exl-loading-dots .exl-dot:nth-child(1) {
  animation-delay: -0.32s;
}
.exl-loading-dots .exl-dot:nth-child(2) {
  animation-delay: -0.16s;
}
.exl-loading-dots .exl-dot:nth-child(3) {
  animation-delay: 0s;
}

/* Loading pulse variant */
.exl-loading-pulse {
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
}

.exl-pulse-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid currentColor;
  border-radius: 50%;
  opacity: 0.4;
  animation: exl-pulse-ring 2s ease-in-out infinite;
}

.exl-pulse-core {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: currentColor;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: exl-pulse-core 2s ease-in-out infinite;
}

/* Loading bars variant */
.exl-loading-bars {
  display: inline-flex;
  gap: 2px;
  align-items: end;
}

.exl-loading-bars .exl-bar {
  width: 4px;
  height: 20px;
  background-color: currentColor;
  border-radius: 2px;
  animation: exl-bars-scale 1.2s ease-in-out infinite;
}

.exl-loading-bars .exl-bar:nth-child(1) {
  animation-delay: -0.4s;
}
.exl-loading-bars .exl-bar:nth-child(2) {
  animation-delay: -0.3s;
}
.exl-loading-bars .exl-bar:nth-child(3) {
  animation-delay: -0.2s;
}
.exl-loading-bars .exl-bar:nth-child(4) {
  animation-delay: -0.1s;
}

/* Responsive utilities */
@media (max-width: 576px) {
  .container {
    max-width: 100%;
  }
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/utilities.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,iCAAiC;;AAEjC,qBAAqB;AACrB;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB,EAAE,kDAAkD;AACvE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB;;;;gCAI8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB;;gCAE8B;AAChC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,wCAAwC;EACxC,0BAA0B;EAC1B;;;iDAG+C;EAC/C,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,uCAAuC;EACvC,sCAAsC;EACtC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,+CAA+C;EAC/C,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,wCAAwC;EACxC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,+CAA+C;EAC/C,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,gEAAgE;EAChE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,iCAAiC;EACjC,qCAAqC;EACrC,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;;EAEE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB,EAAE,kDAAkD;EACtE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,iBAAiB,EAAE,2DAA2D;EAC9E,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,uDAAuD;AACvD;EACE,4BAA4B,EAAE,mDAAmD;EACjF,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB,EAAE,qCAAqC;EACzD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,4BAA4B,EAAE,2DAA2D;EACzF,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,8CAA8C;AAC9C;EACE,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,iDAAiD;AACnD;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Utility Classes */\n\n/* Bootstrap-inspired utilities */\n\n/* Container system */\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n/* Grid system */\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col-md-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n@media (min-width: 768px) {\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n\n/* Flexbox utilities */\n.d-flex {\n  display: flex !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n/* Position utilities */\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n/* Spacing utilities */\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n/* Text utilities */\n.text-center {\n  text-align: center !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n  font-size: 0.9rem; /* Increased from default for better readability */\n}\n\n.text-danger {\n  color: #dc3545 !important;\n}\n\n/* Card components */\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.card-title {\n  margin-bottom: 0.5rem;\n}\n\n.card-text {\n  margin-bottom: 0;\n}\n\n/* Button components */\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  border-radius: 0.25rem;\n  transition:\n    color 0.15s ease-in-out,\n    background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #0056b3;\n  border-color: #004085;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-secondary:hover {\n  color: #fff;\n  background-color: #545b62;\n  border-color: #4e555b;\n}\n\n/* Alert components */\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.alert-danger {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n}\n\n/* Form components */\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition:\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* Enhanced form components */\n.exl-form-group {\n  margin-bottom: 1.5rem;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.exl-form-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  font-weight: 600;\n  font-size: 0.95rem;\n  letter-spacing: -0.005em;\n}\n\n.exl-form-control {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.95rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius);\n  background-color: var(--card-background);\n  color: var(--text-primary);\n  transition:\n    border-color var(--transition-speed) ease,\n    box-shadow var(--transition-speed) ease,\n    background-color var(--transition-speed) ease;\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  min-width: 0;\n  border: 1.5px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  line-height: 1.5;\n  background: var(--card-background);\n}\n\n.exl-form-control:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 0.2rem rgba(30, 58, 95, 0.25);\n  outline: none;\n  caret-color: var(--primary-color);\n  color: var(--text-primary);\n  background-color: var(--card-background);\n  box-shadow: 0 0 0 3px rgba(30, 58, 95, 0.1);\n  transform: translateY(-1px);\n}\n\n.exl-form-control::placeholder {\n  color: var(--text-secondary);\n  opacity: 0.8;\n  opacity: 0.7;\n}\n\n.exl-form-control:focus-visible {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 0.2rem rgba(30, 58, 95, 0.25);\n  outline: none;\n}\n\n/* Enhanced button components */\n.exl-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: 0.75rem 1.5rem;\n  height: 42px;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: var(--border-radius);\n  transition: all var(--transition-speed) var(--transition-spring);\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  gap: 0.5rem;\n  box-sizing: border-box;\n  font-size: 0.95rem;\n  letter-spacing: -0.005em;\n  border-radius: var(--border-radius-sm);\n}\n\n.exl-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.exl-btn:hover::before {\n  left: 100%;\n}\n\n.exl-btn-primary {\n  color: white;\n  background: var(--brand-gradient-solid);\n  border: none;\n  box-shadow: 0 2px 8px var(--brand-glow);\n}\n\n.exl-btn-primary:hover {\n  background: var(--brand-gradient-solid-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px var(--brand-glow);\n}\n\n.exl-btn-secondary {\n  color: var(--text-primary);\n  background: var(--card-background);\n  border-color: var(--border-color);\n  backdrop-filter: var(--backdrop-blur);\n  -webkit-backdrop-filter: var(--backdrop-blur);\n  border: 1.5px solid var(--border-color);\n}\n\n.exl-btn-secondary:hover {\n  background: var(--card-hover);\n  border-color: var(--primary-color);\n  transform: translateY(-1px);\n  color: var(--primary-color);\n}\n\n.exl-btn-block {\n  display: flex;\n  width: 100%;\n}\n\n.exl-btn:focus-visible {\n  outline: 2px solid var(--primary-color);\n  outline-offset: 2px;\n  box-shadow: 0 0 0 4px rgba(30, 58, 95, 0.15);\n}\n\n/* Pagination */\n.exl-pagination {\n  display: flex;\n  justify-content: center;\n  margin: 2rem 0;\n}\n\n.exl-pagination .pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: var(--border-radius);\n}\n\n.exl-pagination .pagination li a {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: var(--primary-color);\n  background-color: var(--card-background);\n  border: 1px solid var(--border-color);\n}\n\n.exl-pagination .pagination li:first-child a {\n  margin-left: 0;\n  border-top-left-radius: var(--border-radius);\n  border-bottom-left-radius: var(--border-radius);\n}\n\n.exl-pagination .pagination li:last-child a {\n  border-top-right-radius: var(--border-radius);\n  border-bottom-right-radius: var(--border-radius);\n}\n\n.exl-pagination .pagination li a:hover {\n  z-index: 2;\n  color: var(--primary-dark);\n  background-color: #e9ecef;\n  border-color: var(--border-color);\n}\n\n.exl-pagination .pagination li.active a {\n  z-index: 3;\n  color: var(--text-light);\n  background-color: var(--primary-color);\n}\n\n.exl-pagination .pagination li.disabled a {\n  color: var(--text-secondary);\n  pointer-events: none;\n  background-color: var(--card-background);\n  border-color: var(--border-color);\n}\n\n/* Container for the pagination */\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px;\n}\n\n/* Remove default list styling */\n.pagination li {\n  display: inline;\n}\n\n/* Style the page links */\n.pagination li a,\n.pagination li span {\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  margin-left: -1px;\n  line-height: 1.42857143;\n  color: #337ab7;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n\n/* First and last child rounded corners */\n.pagination li:first-child a {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.pagination li:last-child a {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n/* Hover state */\n.pagination li a:hover {\n  background-color: #eee;\n  color: #23527c;\n}\n\n/* Active state */\n.pagination li.active a {\n  background-color: #337ab7;\n  border-color: #337ab7;\n  color: #fff;\n  cursor: default;\n}\n\n/* Disabled state */\n.pagination li.disabled a {\n  color: #777;\n  cursor: not-allowed;\n  background-color: #fff;\n  border-color: #ddd;\n}\n\n/* Small text - Improved readability */\nsmall {\n  font-size: 0.95rem; /* Increased from 0.875em for better readability */\n  font-weight: 400;\n}\n\n/* Form validation feedback - Improved readability */\n.invalid-feedback {\n  font-size: 0.9rem; /* Increased from typical 0.875rem for better readability */\n  font-weight: 500;\n  margin-top: 0.25rem;\n  color: var(--danger-color);\n}\n\n/* Password strength indicator - Improved readability */\n.small {\n  font-size: 0.9rem !important; /* Increased from 0.875rem for better readability */\n  font-weight: 400;\n}\n\n/* Form check labels - Improved readability */\n.form-check-label {\n  font-size: 0.95rem; /* Increased for better readability */\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n/* Bootstrap alert overrides - Improved readability */\n.alert {\n  font-size: 0.9rem !important; /* Increased from typical 0.875rem for better readability */\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.alert-danger {\n  font-size: 0.9rem !important;\n}\n\n.alert-success {\n  font-size: 0.9rem !important;\n}\n\n.alert-warning {\n  font-size: 0.9rem !important;\n}\n\n/* Ensure password strength text is readable */\n.mt-1.small.text-muted {\n  font-size: 0.9rem !important;\n}\n\n/* Spinner Components */\n.exl-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  width: 100%;\n  gap: 1rem;\n}\n\n.exl-loading-text {\n  margin: 0;\n  color: #6c757d;\n  font-size: 0.9rem;\n}\n\n.exl-spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: exl-spin 1s linear infinite;\n}\n\n.exl-spinner-small {\n  width: 16px;\n  height: 16px;\n  border-width: 2px;\n}\n\n.exl-spinner-medium {\n  width: 20px;\n  height: 20px;\n  border-width: 2px;\n}\n\n.exl-spinner-large {\n  width: 24px;\n  height: 24px;\n  border-width: 3px;\n}\n\n.exl-spinner-primary {\n  border-color: rgba(30, 58, 95, 0.3);\n  border-top-color: var(--primary-color);\n}\n\n.exl-spinner-white {\n  border-color: rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n}\n\n/* Button spinner container alignment */\n.exl-btn .exl-spinner {\n  vertical-align: middle;\n}\n\n/* Ensure spinner containers within buttons are properly aligned */\n.exl-btn > span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n/* Loading dots variant */\n.exl-loading-dots {\n  display: inline-flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.exl-loading-dots .exl-dot {\n  width: 8px;\n  height: 8px;\n  background-color: currentColor;\n  border-radius: 50%;\n  animation: exl-dots-bounce 1.4s ease-in-out infinite both;\n}\n\n.exl-loading-dots .exl-dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n.exl-loading-dots .exl-dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n.exl-loading-dots .exl-dot:nth-child(3) {\n  animation-delay: 0s;\n}\n\n/* Loading pulse variant */\n.exl-loading-pulse {\n  position: relative;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n}\n\n.exl-pulse-ring {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 2px solid currentColor;\n  border-radius: 50%;\n  opacity: 0.4;\n  animation: exl-pulse-ring 2s ease-in-out infinite;\n}\n\n.exl-pulse-core {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  background-color: currentColor;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  animation: exl-pulse-core 2s ease-in-out infinite;\n}\n\n/* Loading bars variant */\n.exl-loading-bars {\n  display: inline-flex;\n  gap: 2px;\n  align-items: end;\n}\n\n.exl-loading-bars .exl-bar {\n  width: 4px;\n  height: 20px;\n  background-color: currentColor;\n  border-radius: 2px;\n  animation: exl-bars-scale 1.2s ease-in-out infinite;\n}\n\n.exl-loading-bars .exl-bar:nth-child(1) {\n  animation-delay: -0.4s;\n}\n.exl-loading-bars .exl-bar:nth-child(2) {\n  animation-delay: -0.3s;\n}\n.exl-loading-bars .exl-bar:nth-child(3) {\n  animation-delay: -0.2s;\n}\n.exl-loading-bars .exl-bar:nth-child(4) {\n  animation-delay: -0.1s;\n}\n\n/* Responsive utilities */\n@media (max-width: 576px) {\n  .container {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 576px) {\n  .container {\n    max-width: 540px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 720px;\n  }\n}\n\n@media (min-width: 992px) {\n  .container {\n    max-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1140px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
